import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {ScheduleCalendar, ScheduleCalendarRange} from '../../domain/schedule-calendar';
import type {ScheduleRepository} from '../ports/schedule.repository';

export class GetScheduleCalendar implements UseCase<
  [ScheduleCalendarRange | null],
  ScheduleCalendar
> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(range: ScheduleCalendarRange | null): Promise<Result<ScheduleCalendar, ScheduleError>> {
    return this.repository.getCalendar(range);
  }
}
